import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { createQueryClient } from './api';
import { ErrorBoundary } from './app/ErrorBoundary';
import { rootErrorOptions } from './app/error-reporting';
import { AppProviders } from './app/providers';
import { AppRoutes } from './app/routes';
import './styles/global.css';

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!, rootErrorOptions).render(
  <StrictMode>
    {/* Por fora de tudo: uma falha em qualquer rota ou provedor mostra a mensagem, não tela branca. */}
    <ErrorBoundary>
      <BrowserRouter>
        <AppProviders queryClient={queryClient}>
          <AppRoutes />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
